module.exports = __webpack_public_path__ + "2d4fb50f558837f0c3e7667f4d21f90b.svg";